import React from "react";
import { tone, toMin, ymd } from "./typeColors";

const HOURS = Array.from({ length: 13 }, (_, i) => i + 7); // 7am - 7pm
const PX_PER_MIN = 0.9; // 54px per hour

export default function DayView({ date, appts, onOpen, onCreate }) {
  const key = ymd(date);
  const list = appts.filter((a) => a.date === key);

  return (
    <div data-testid="cal-day-view" className="flex">
      <div className="flex flex-col w-16 pr-2 shrink-0">
        {HOURS.map((h) => (
          <div key={h} className="text-[10px] font-mono text-slate-400 text-right pt-2" style={{ height: `${60 * PX_PER_MIN}px` }}>
            {String(h).padStart(2, "0")}:00
          </div>
        ))}
      </div>
      <div className="relative flex-1 border-l border-slate-200 dark:border-white/10">
        {HOURS.map((h) => (
          <button
            key={h}
            data-testid={`cal-day-slot-${h}`}
            onClick={() => onCreate({ date: key, time: `${String(h).padStart(2, "0")}:00` })}
            className="block w-full border-b border-slate-100 dark:border-white/5 hover:bg-indigo-50/40 dark:hover:bg-indigo-500/10 transition-colors"
            style={{ height: `${60 * PX_PER_MIN}px` }}
          />
        ))}
        {list.map((a) => {
          const start = toMin(a.time) - HOURS[0] * 60;
          const end = a.end_time ? toMin(a.end_time) - HOURS[0] * 60 : start + 60;
          const top = Math.max(0, start * PX_PER_MIN);
          const height = Math.max(28, (end - start) * PX_PER_MIN);
          const t = tone(a.type);
          return (
            <button
              key={a.id}
              data-testid={`cal-day-appt-${a.id}`}
              onClick={() => onOpen(a)}
              className={`absolute left-2 right-2 rounded-xl text-left p-2.5 border shadow-sm hover:shadow-md transition-all ${t.soft}`}
              style={{ top: `${top}px`, height: `${height}px` }}
            >
              <div className="flex items-center gap-1.5 text-[10px] font-mono opacity-80">
                <span className={`inline-block h-1.5 w-1.5 rounded-full ${t.bg}`} />
                {a.time}{a.end_time ? ` – ${a.end_time}` : ""}
              </div>
              <div className="text-sm font-semibold truncate">{a.title}</div>
              <div className="text-[11px] opacity-80 truncate">
                {a.client}{a.consultant ? ` · ${a.consultant}` : ""}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
